import { SvgIconComponent } from "@mui/icons-material";
import { MvInputInterface } from "@mv-components/types";
import { SORT_ORDER } from "core/modules/table/constants";

// User Data Interfaces
export interface RouteInterface {
	id?: string;
	key?: string;
	access?: string[];
	[key: string]: any;
}

export interface RouteListInterface extends Array<RouteInterface> {}

export interface UserDataInterface {
	displayName: string;
	userType: string;
	online: boolean;
	permissions: string[];
}

// Menu and Route Interfaces
export interface AppRouteInterface {
	component: React.LazyExoticComponent<(props: any) => JSX.Element>;
	path?: string;
	menuLabel: string;
	subMenus?: SubMenuInterface[];
}
export interface AppRouteMapInterface {
	[key: string]: AppRouteInterface;
}

export interface AppMenuInterface {
	path?: string;
}

export interface MenuInterface {
	menuLabel: string;
	path?: string;
	subMenus?: SubMenuInterface[];
}

export interface SubMenuInterface {
	path?: string;
	menuLabel?: string;
}

// form interfaces

export enum InputType {
	RADIO_LABEL = "radioLabel",
	INPUT = "input",
	BUTTON = "button",
	DATE = "date",
	DATE_TIME = "date_time",
	DATE_RANGE = "date_range",
	ACCORDION_DATE_TIME = "accordionDateTime",
	CHECKBOX = "checkbox",
	CHECKBOX_GROUP = "checkboxGroup",
	LINK = "link",
	SEARCH = "search",
	SELECT = "select",
	AUTOCOMPLETE = "autoComplete",
	BUTTON_CHECKBOX_GROUP = "buttonCheckboxGroup",
	BUTTON_RADIO_GROUP = "buttonRadioGroup",
	BUTTON_RADIO_DATE_GROUP = "buttonRadioDateGroup",
	RANGE_SLIDER = "rangeSlider",
	ACCORDION_CHECKBOX_GROUP = "accordionCheckboxGroup",
	INPUT_TYPE_GROUP = "inputGroup",
	FILE = "file",
}

export interface ControlModelItemInterface {
	disabled?: boolean;
	name?: string;
	elementType: InputType;
	itemKey: string;
	label?: string;
	helperText?: string;
	value: object | string;
	labelPlacement?: string;
	placeholder?: string;
	options?: Array<{ label: any; value: any }>;
	validations: {
		rules: { [key: string]: any };
		messages: { [key: string]: string };
	};
	valid: {
		isValid: boolean;
		invalidRule: string;
	};
	error?: boolean;
	touched: boolean;
	checkFromVisibility?: (controls: ControlModelInterface, extraData?: any) => boolean;
	displayInlineBlock?: boolean;
	breakAfter?: boolean;
	className?: string;
	multiline?: boolean;
	rows?: number;
	getMinDateTime?: (controls: any | undefined) => any;
	isDisabled?: (controls: any) => boolean;
	minWidthClassName?: string;
	errorText?: string;
	dispatchAction?: (({ event, itemKey, value }: any) => any) | undefined;
	prependText?: string | ((props: any | undefined) => string);
	apiKey?: string;
	suffix?: string;
	appendText?: string | ((props: any | undefined) => string);
	updateFromMetaKey?: "value" | "options";
	style?: any;
	additionalProps?: any;
	customClasses?: { [key: string]: string };
	iconToAppend?: { type: string; content: string };
	order?: number;
	optionUrl?: string;
	enableSearch?: boolean;
	uploadUrl?: string;
	fileTypeAccept?: string;
	doNotReset?: boolean;
	referenceValue?: object | string;
	remoteValidation?: {
		url: string;
		errorMessage: string;
		type: string;
	};
}

export interface ControlModelInterface {
	[key: string]: MvInputInterface & {
		checkFromVisibility?: (controls: ControlModelInterface, extraData?: any) => boolean;
		displayInlineBlock?: boolean;
		breakAfter?: boolean;
		valueKey?: string;
	};
}

export interface InstructionsBodyInterface {
	text: String;
}

// from
export interface FormOnChangeArgs {
	event: any;
	itemKey: string;
	value?: any;
	formName?: string;
	[key: string]: any;
}
export type FormOnChange = (args: FormOnChangeArgs) => void;

// redux

export interface ReduxAction {
	type: string;
	[key: string]: any;
}

export interface AccordionIconPropsInterface {
	iconPlacement: "left" | "right";
	customIconOpen?: SvgIconComponent;
	customIconClose?: SvgIconComponent;
	customTriggerClass?: string;
	customIconsClass?: string;
}

export interface ErrorObjectInterface {
	errorCode: string;
	errorTitle: string;
	errorMessage?: string;
}

export interface ActionDataInterface {
	type?: string;
	label?: string;
	getViewConfig?: (rowData: any) => { path?: string; label?: string };
	conditionKey?: string;
}

export interface ColumnKeyInterface {
	textFormatter?: (value: string) => string;
	component?: string;
	classMap?: any;
	handleNA?: boolean;
	isAction?: boolean;
	actionData?: {
		[key: string]: ActionDataInterface[];
	};
	subComponent?: string;
	className?: string;
	valueMap?: any[];
	customWidth?: string;
	trimLength?: number;
	defaultValue?: string;
	subLabel?: string;
	columnClassName?: { [key: string]: string };
	columnClickConfig?: any;
	showCopy?: any;
	visibilityKey?: string;
}

interface TableModelHeaderInterface {
	key: string;
	sortAble?: boolean;
	sortType?: string;
	sortOrder?: SORT_ORDER;
}

export interface TableModelInterface {
	title?: string | boolean;
	header: TableModelHeaderInterface[];
	columnKey: { [key: string]: ColumnKeyInterface };
	rowModels?: any;
	isSelectCheckBoxTable?: boolean;
	selectCheckboxConfig?: {
		actionLabel?: string;
		actionType?: string;
		uniQueMappingKey: string;
	};
	rowColorMapping?: {
		columnName: string;
		colorMap: {
			[key: string]: string;
		};
	};
	copyConfig?: any;
	headerActionConfig?: Array<{
		label: string;
		identifier: string;
	}>;
}
